import $i18n from '@/locale-view/i18n';
import { ValidatorPosition } from '../../position/validator-position';
export const config = {
    value: 'checkObjectValues',
    position: [
        ValidatorPosition.filter,
        ValidatorPosition.form,
        ValidatorPosition.formDialog,
        ValidatorPosition.cnArrayTable,
        ValidatorPosition.cnArraySubAreaCard,
    ],
    action: () => {
        return {
            validator: (value) => {
                if (!value || typeof value !== 'object')
                    return false;
                const hasEmpty = Object.values(value).some((item) => {
                    if (item === null || item === undefined)
                        return true;
                    if (typeof item === 'string')
                        return item.trim() === '';
                    if (Array.isArray(item))
                        return item.length === 0;
                    if (typeof item === 'object')
                        return Object.keys(item).length === 0;
                    return false;
                });
                if (hasEmpty) {
                    return $i18n.get({
                        id: 'PleaseEnterFullContent',
                        dm: '请输入完整内容',
                    });
                }
                return true;
            },
        };
    },
};
